// Groups digits and uses Persian digits in the Persian UI
export const formatNumber = (value: number, lang: string): string =>
    value.toLocaleString(lang === "fa" ? "fa-IR" : "en-US");

